<template>
    <div class="af-jobview-action-btns afu-w-full afu-p-4 afu-bg-white afu-text-center afu-fixed afu-bottom-0 afu-left-0 afu-z-1000 afu-flex afu-gap-2 afu-box-border">
        <C1Button
            type="button"
            variant="primary"
            @click.stop.prevent="applyNow()"
            :disabled="isExpired"
            size="lg"
            class="af-btn-apply afu-font-bold afu-w-full"
        >
            <template
                v-if="isCompleteApply"
            >
                {{ $t('label.apply_again') }}
            </template>
            <template
                v-else-if="isExpired"
            >
                {{ $t('job_view.expired') }}
            </template>
            <template
                v-else
            >
                {{ $t('label.apply_now') }}
            </template>

            <FontAwesomeIcon
                :icon="['fas', 'arrow-right']"
                size="md"
                class="afu-ml-3"
            />
        </C1Button>
        <JobViewActionsMobile />
        <ShareJobMobile />
    </div>
</template>

<script>
    import ApplyJobMixin from './ApplyJobMixin';
    import JobViewActionsMobile from './../JobViewActionsMobile';
    import ShareJobMobile from './ShareJobMobile';

    export default {
        name: 'ApplyJobMobile',

        components: {
            JobViewActionsMobile,
            ShareJobMobile,
        },

        mixins: [
            ApplyJobMixin,
        ],
    };
</script>
